/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/alt-text */
import moment from 'moment';
import { useMemo, useState } from 'react';

import FooterEnd from 'comman/component/footerEnd';
import RcdImageComponent from 'comman/component/rcdImage.component';
import { ErrorMessage, Field, FieldArray, Form, Formik } from 'formik';
import { IMAGE_TYPE } from 'helper/constant/gallery';
import { useEffect } from 'react';
import { Button, Card, Modal, Spinner } from 'react-bootstrap';
import { connect } from 'react-redux';
import Select, { components } from 'react-select';
import { deleteGallery, searchGallery, updateGallery } from 'services/gallery';
import swal from 'sweetalert';
import * as Yup from 'yup';
import defaultGallery from '../assets/img/gallery_default.png';
import fullScreenDefault from '../assets/img/gradient_ringer_default.png';
import noUser from '../assets/img/no_user.jpg';
import { ReactComponent as EditIcon } from '../assets/svg/edit.svg';
import { ReactComponent as GridIcon } from '../assets/svg/grid.svg';
import { ReactComponent as ListIcon } from '../assets/svg/list.svg';
import { ReactComponent as TrashIcon } from '../assets/svg/remove.svg';
import GalleryImage from '../comman/component/galleryImage.component';
import ImageModal from '../comman/component/imageEditorModal.component';
import TableComponent from '../comman/component/table';
import MyDropZoneLogo from '../comman/component/uploadfile.logo';
import { hotFixCreateBlobUrl } from '../helper/binarytoblob';
import { convertArrayToObject, useDebounce } from '../helper/comman';
import {
  addGalleryIdToUrl,
  addNameToUrl,
  getGalleryIdFromUrl,
  getOnlyFirstName,
  getPublicUrl,
  updateImage,
  uploadImage,
} from '../helper/galleyHelper';
import {
  setModalAction,
  setShowModal,
} from '../redux/active-tabs/active-tab.action';
import { showToast } from '../redux/auth/auth.action';
import { searchContacts, updateContacts } from '../services/contacts';
import ImageEditorModal from 'container/ImageEditor/ImageEditorModal';
import gradientDefaultRinger from '../assets/img/gradient_ringer_default.png';

const MultiValueLabelCustom = (props) => {
  return (
    <components.MultiValueLabel
      {...props}
      children={getOnlyFirstName(props.data?.label)}
    />
  );
};

const validationSchemaImage = Yup.object().shape({
  logo: Yup.string().url('Url not valid').required('Logo is required'),
  fullImage: Yup.string()
    .url('Url not valid')
    .required('Full screen is required'),
});

const validationSchema = Yup.object().shape({
  galleryName: Yup.string().required('Name is required'),
  imageUrl: Yup.string().required('Image is required'),
});

const stylesSelectAssign = {
  multiValue: (base, state) => {
    return state.data.isFixed ? { ...base, backgroundColor: 'gray' } : base;
  },
  multiValueLabel: (base, state) => {
    return state.data.isFixed
      ? { ...base, fontWeight: 'bold', color: 'white', paddingRight: 6 }
      : base;
  },
  multiValueRemove: (base, state) => {
    return state.data.isFixed ? { ...base, display: 'none' } : base;
  },
};

const orderOptions = (values) => {
  return values
    .filter((v) => v.isFixed)
    .concat(values.filter((v) => !v.isFixed));
};

const GalleryView = ({
  setToaster,
  showModal,
  setShowModal,
  setModalAction,
  modalAction,
  userRole,
}) => {
  const [isFirstLoading, setIsFirstLoading] = useState(true);

  const [galleryData, setGalleryData] = useState([]);
  const [rcdDataFullById, setRCDDataFullById] = useState();
  const [rcdOptionsAssign, setRcdOptionsAssign] = useState([]);
  const [galleryImages, setGalleryImages] = useState([]);
  const [profile, setProfile] = useState([]);
  const [profileImage, setProfileImage] = useState([]);
  const [showImageEditor, setShowImageEditor] = useState(false);
  const [tab, setTab] = useState(1);
  const [imageEditData, setImageEditData] = useState();
  const [showGalleryModal, setShowGalleryModal] = useState(false);
  const [profileDropzone, setProfileDropzone] = useState(false);
  const [galleryFileName, setGalleryFileName] = useState(false);
  const [isUploadImage, setIsUploadImage] = useState(false);
  const [imageContactData, setImageContactData] = useState([]);
  const [galleryListView, setGalleryListView] = useState('list');
  const [contactData, setContactData] = useState();
  const [filterContact, setFilterContact] = useState([]);
  const [removeGalleryIdContact, setRemoveGalleryIdContact] = useState();
  const [gallerySortType, setGallerySortType] = useState('name');
  const [tableKeyState, setTableKeyState] = useState(1);
  const [blobURL, setBlobURL] = useState({
    previous: '',
    current: '',
    next: '',
  });
  const [galleryAssigned, setGalleryAssigned] = useState(new Set());

  const initialPreviewScreen = {
    name: '',
    // imageUrl: noUser,
    image: noUser,
  };
  // const initialValues = {
  //   name: '',
  //   contactId: [],
  // };
  const [initialValues, setInitialValues] = useState({
    name: '',
    contactId: [],
    isLogo: false,
    imageUrl: '',
    galleryName: '',
  });
  const [editInitialValues, setEditInitialValues] = useState({
    id: '',
    galleryId: '',
    name: '',
    contactId: [],
  });

  const [previewScreen, setPreviewScreen] = useState(initialPreviewScreen);

  const [filterGallery, setFilterGallery] = useState({
    label: 'Select All',
    value: 'all',
  });

  const [filterGalleryAssign, setFilterGalleryAssign] = useState({
    label: 'Select All',
    value: 'all',
  });

  const [searchText, setSearchText] = useState(() =>
    window.sessionStorage.getItem('gallery_search_text')
  );

  const [editImageData, setEditImageData] = useState({
    isOpen: false,
    imageUrl: '',
    type: '',
    galleryName: '',
  });

  const handleClose = () => {
    setShowModal(false);
  };

  const imageHandleClose = () => {
    setTab(1);
    setShowImageEditor(false);
    setPreviewScreen((prevState) => ({
      ...prevState,
      image: imageEditData ? imageEditData : noUser,
    }));
    setImageEditData && setImageEditData(null);
  };

  useEffect(() => {
    setShowModal(false);
    fetchData(searchText || '');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // useEffect for sorting type
  // useEffect(() => {
  //   // console.log('inside use effect');
  //   let sortData;
  //   if (gallerySortType === 'name') {
  //     sortData = [...galleryData].sort((a, b) => {
  //       return a.name?.localeCompare?.(b?.name);
  //     });
  //     setGalleryData(sortData);
  //     setTableKeyState(Math.random());
  //   }
  //   if (gallerySortType === 'filename') {
  //     sortData = [...galleryData].sort((a, b) => {
  //       return a.avatar?.localeCompare?.(b?.avatar);
  //     });
  //     setGalleryData(sortData);
  //     setTableKeyState(Math.random());
  //   }
  // }, [gallerySortType]);

  useEffect(() => {
    if (modalAction === 'add') {
      setFilterContact([]);
    }
  }, [modalAction]);

  const fetchData = async (value) => {
    const [res, resRCD] = await Promise.all([
      searchGallery({ q: value || '*' }),

      searchContacts({
        q: '',
      }),
    ]);
    const rcdListFull = [];
    const rcdOptionsAssign = [];

    if (resRCD.status === 200) {
      if (resRCD.data.total > 0) {
        resRCD.data.objects.forEach((item) => {
          rcdOptionsAssign.push({
            value: {
              id: item._id,
              number: item.phone.join(', '),
              fullName: [item.firstName, item.lastName].join(' '),
            },
            label: item.firstName + ' ' + item.lastName,
          });
          try {
            const formatData = {
              ...item,
            };

            rcdListFull.push({ ...formatData });
          } catch (error) {}
        });

        setRCDDataFullById(convertArrayToObject(rcdListFull, '_id'));
        setRcdOptionsAssign(rcdOptionsAssign);
      }
    }

    if (res.status === 200) {
      if (res.data.total > 0) {
        const galleryList = [];
        res.data?.objects?.forEach((item) => {
          if (
            (item.type === IMAGE_TYPE.LOGO ||
              item.type === IMAGE_TYPE.FULLSCREEN) &&
            item.logoName !== 'DEFAULT_LOGO' &&
            item.logoName !== 'DEFAULT_FULLSCREEN'
          ) {
            try {
              const formatData = {
                ...item,
                imageUrl: getPublicUrl(item.avatar) || '',
                id: item.galleryId || '',
                isLogo: item.type === IMAGE_TYPE.LOGO,
                galleryId: item.galleryId,
                galleryName: item.name || '',
              };

              // Yup.string().url().required().validateSync(item.publicURL, {
              //   abortEarly: false,
              // });

              galleryList.push({ ...formatData });
            } catch (error) {}
          }
        });

        setGalleryData(
          galleryList.map((item) => ({
            ...item,
            contactId: rcdListFull
              .filter(
                (rcdItem) =>
                  rcdItem.circleGalleryId === item.galleryId ||
                  rcdItem.galleryId === item.galleryId
              )
              .map((item) => item._id),
          }))
        );
      } else {
        setGalleryData([]);
      }
    }

    setIsFirstLoading(false);
  };

  const searchData = useDebounce(async (value) => {
    await fetchData(value);
  }, 300);

  // function syncRefGallery(checkId, isLogo, rcdDataFull) {
  //   // console.log('checkId, isLogo, rcdDataFull', checkId, isLogo, rcdDataFull);
  //   const listRef =
  //     rcdDataFull?.filter((item) => {
  //       const galleryId = getGalleryIdFromUrl(
  //         isLogo ? item.logo : item.fullImage
  //       );
  //       return item._id !== checkId && galleryId === checkId;
  //     }) || [];

  //   // console.log('listRef', listRef);
  //   listRef.forEach((item) => {
  //     if (isLogo) {
  //       updateContacts(item._id, {
  //         ...item,
  //         logo: item.logo,
  //       });
  //     } else {
  //       updateContacts(item._id, {
  //         ...editInitialValues,
  //         fullImage: item.fullImage,
  //       });
  //     }
  //   });

  //   // checkId
  // }

  const submitFunction = async (value) => {
    try {
      const { _id, contactId: oldContactId } = editInitialValues;
      let isLogo = editInitialValues.isLogo;

      if (modalAction === 'add') {
        isLogo = value.isLogo;
        if (value.isLogo) {
          const resFullImage = await uploadImage([value.logoFile], {
            type: IMAGE_TYPE.LOGO,
            avatar: value.galleryName,
          });
          // value.fullImage = resFullImage.publicURL;
          // value.logoId = resFullImage.logoId;
          value.galleryId = resFullImage.galleryId;
          // value.circleGalleryId = resFullImage.galleryId;
        } else {
          const resFullImage = await uploadImage([value.fullImageFile], {
            type: IMAGE_TYPE.FULLSCREEN,
            avatar: value.galleryName,
          });
          value.galleryId = resFullImage.galleryId;
          // value.fullImage = resFullImage.publicURL;
          // value.logoId = resFullImage.logoId;
        }
      } else {
        if (isLogo) {
          if (value.logoFile) {
            await updateImage(
              value.galleryId,
              [
                value.logoFile || {
                  preview: value.imageUrl,
                },
              ],
              {
                type: IMAGE_TYPE.LOGO,
                avatar: value.galleryName,
              }
            );
          } else {
            await updateGallery(value.galleryId, {
              name: value.galleryName,
            });
          }
        } else {
          if (value.fullImageFile) {
            await updateImage(
              value.galleryId,
              [
                value.fullImageFile || {
                  preview: value.imageUrl,
                },
              ],
              {
                type: IMAGE_TYPE.FULLSCREEN,
                avatar: value.galleryName,
              }
            );
          } else {
            await updateGallery(value.galleryId, {
              name: value.galleryName,
            });
          }
        }
      }

      if (value.rcdAssign) {
        const listUpdate = value.rcdAssign.filter((item) => !item.isFixed);
        const listDelete =
          oldContactId
            ?.map((assignId) => {
              const currentData = rcdOptionsAssign.find(
                (item) => item.value.id === assignId
              );
              return currentData || null;
            })
            .filter((item) => {
              return (
                item &&
                item.value.id !== _id &&
                !listUpdate.some(
                  (itemUpdate) => itemUpdate.value.id === item.value.id
                )
              );
            }) || [];
        const currentListRcdFull = Object.values(rcdDataFullById);
        // console.log('listUpdate', listUpdate);
        // console.log('listDelete', listDelete);
        // console.log('value', value);
        await Promise.all(
          listUpdate.map((item) => {
            const { value: updateItem } = item;
            const currentData = rcdDataFullById[updateItem?.id];

            if (!currentData) return null;
            if (isLogo) {
              return updateContacts(currentData._id, {
                ...currentData,
                circleGalleryId: value.galleryId,
              });
            } else {
              return updateContacts(currentData._id, {
                ...currentData,
                galleryId: value.galleryId,
              });
            }
          })
        );

        await Promise.all(
          listDelete.map((item) => {
            const { value: updateItem } = item;
            const currentData = rcdDataFullById[updateItem?.id];

            if (!currentData) return null;
            if (isLogo) {
              return updateContacts(currentData._id, {
                ...currentData,
                circleGalleryId: null,
              });
            } else {
              return updateContacts(currentData._id, {
                ...currentData,
                galleryId: null,
              });
            }
          })
        );
      }

      const data = {
        show: true,
        message: 'Gallery Successfully Updated',
      };
      setToaster(data);
      searchData(searchText || '');
      setShowModal(false);
      setModalAction(null);
    } catch (error) {
      console.log('error', error);
    }
  };
  const handleRemove = async (value) => {
    try {
      // console.log('value', value);

      const wrapper = document.createElement('div');
      wrapper.innerHTML =
        '<p class="swal-text-data">Are you sure you want to delete this gallery?</p> ' +
        '<p class="swal-text-data">Deleting a gallery is a permanent action. Once removed it cannot be restored or modified</p>';
      swal({
        title: 'Delete Confirmation',
        content: wrapper,
        buttons: {
          confirm: {
            width: 30,
            text: 'Delete',
            value: 'delete',
            visible: true,
            className: 'swal-delete-button',
            closeModal: true,
          },
          cancel: {
            width: 15,
            text: 'Cancel',
            value: 'cancel',
            visible: true,
            className: 'swal-cancel-button',
            closeModal: true,
          },
        },
      }).then(async (willDelete) => {
        if (willDelete === 'delete') {
          const { _id, isLogo, galleryId, contactId } = value;

          await deleteGallery(galleryId);

          // syncRefGallery(_id, isLogo, Object.values(rcdDataFullById));
          const data = {
            show: true,
            message: 'Delete Successfully',
          };
          setToaster(data);
          fetchData(searchText || '');
        }
      });
    } catch (error) {}
  };

  const columns = [
    {
      name: 'Gallery Name',
      selector: (row) =>
        row['galleryName']?.length > 20
          ? row['galleryName'].substring(0, 15) + '...'
          : row['galleryName'] || '-',
      sortable: true,
      sortFunction: (rowA, rowB, cId) => {
        return rowA.galleryName?.localeCompare?.(rowB?.galleryName);
      },
    },
    {
      name: 'Updated At',
      selector: (row) => moment(row['modifiedAt'] * 1000).format('MM/DD/YYYY'),
      sortable: true,
    },
    {
      name: 'Image',
      cell: (row) => {
        return (
          <img
            className='table-user-img'
            src={row.imageUrl}
            onError={(e) => {
              e.target.src = defaultGallery;
            }}
            alt=''
          />
        );
      },
      // sortable: true,
    },
    {
      name: 'Type',
      selector: (row) => (row.isLogo ? 'Thumbnail' : 'Full Screen'),
      // sortable: true,
      // sortFunction: (rowA, rowB, cId) => {
      //   return rowA.isLogo ? 1 : -1;
      // },
    },
    {
      name: 'Edit Gallery',
      button: true,
      omit: userRole && userRole !== 'Administrator' && true,
      cell: (row) => {
        return (
          <div className='d-flex action-btn'>
            <button
              className='btn btn-sm'
              style={{ marginRight: '5px' }}
              // onClick={() =>
              //   editGallery(
              //     setModalAction,
              //     setEditInitialValues,
              //     setPreviewScreen,
              //     initialPreviewScreen,
              //     setShowModal,
              //     row,
              //     imageContactData,
              //     setFilterContact,
              //     setRemoveGalleryIdContact
              //   )
              // }

              onClick={() => {
                setModalAction('edit');
                setPreviewScreen((prevState) => ({
                  ...initialPreviewScreen,
                  name: row.galleryName || '',
                }));
                setEditInitialValues((prevState) => ({
                  ...prevState,
                  ...row,
                  id: row._id,
                  name: row.galleryName || '',
                }));
                setShowModal(true);
              }}>
              <EditIcon />
            </button>
          </div>
        );
      },
    },
    {
      name: 'Delete Gallery',
      button: true,
      omit: userRole && userRole !== 'Administrator' && true,
      cell: (row) => {
        return (
          <div className='d-flex action-btn'>
            <button
              className='btn text-danger btn-sm'
              // onClick={() =>
              //   removeGallery(
              //     row._id,
              //     setGalleryData,
              //     galleryData,
              //     imageContactData
              //   )
              // }
              onClick={() => handleRemove({ ...row })}>
              <TrashIcon />
            </button>
          </div>
        );
      },
    },
  ];

  const handleImageEditClick = (editValues) => {
    if (modalAction === 'add') {
      setIsUploadImage(true);
      setProfileDropzone(!profileDropzone);
    } else if (modalAction === 'edit') {
      setGalleryFileName(`${editValues.name}.png`);
      setIsUploadImage(false);
      // const blob = CreateBlobUrl(galleryImages[editValues.id]);
      // const test = URL.createObjectURL(blob);
      const test = hotFixCreateBlobUrl(galleryImages[editValues.id]);

      setBlobURL({
        previous: test,
        current: test,
        next: test,
      });
      setShowImageEditor(true);
    }
  };

  const contactSelectFunction = (option, actionMeta, setFiledValue) => {
    let contactIdArray = [];

    if (option.length > 0) {
      option.forEach((item) => {
        contactIdArray.push(item);
      });
    } else {
      contactIdArray = [];
    }

    if (actionMeta.action === 'clear') {
      const findItem = rcdOptionsAssign.find(
        (v) => v.value.id === editInitialValues?.id
      );

      if (findItem) {
        contactIdArray = [{ ...findItem }];
      }
    }

    setFiledValue('rcdAssign', contactIdArray);
    setFiledValue(
      'contactId',
      contactIdArray.map((item) => item.value.id)
    );
  };

  const customFilterSelectContact = (option, searchText) => {
    // console.log('option', option, searchText);
    if (
      option?.value?.fullName
        .toLowerCase()
        .includes(searchText.toLowerCase()) ||
      option?.value?.number.toLowerCase().includes(searchText.toLowerCase())
    ) {
      return true;
    } else {
      return false;
    }
  };

  function handleCloseEditImage() {
    setEditImageData((prevState) => ({
      ...prevState,
      isOpen: false,
      type: 'fullscreen',
    }));
  }

  useEffect(() => {
    window.sessionStorage.setItem('gallery_search_text', searchText || '');
  }, [searchText]);

  const gallerySortTypeOptions = [
    {
      value: 'name',
      label: 'Name',
    },
    {
      value: 'filename',
      label: 'Filename',
    },
  ];

  const filterGalleryData = useMemo(() => {
    let result = [...galleryData];
    if (filterGallery) {
      switch (filterGallery.value) {
        case 'fullImage':
          result = result.filter((item) => !item.isLogo);
          break;
        case 'logo':
          result = result.filter((item) => item.isLogo);
          break;
        default:
      }
    }

    if (filterGalleryAssign) {
      switch (filterGalleryAssign.value) {
        case 'assigned':
          result = result.filter((item) => item.contactId?.length > 0);
          break;
        case 'unassigned':
          result = result.filter((item) => item.contactId?.length === 0);
          break;
        default:
      }
    }
    // if (searchText) {
    //   result = result.filter((item) =>
    //     (item.galleryName?.toLocaleLowerCase() || '').includes(
    //       searchText?.toLocaleLowerCase() || ''
    //     )
    //   );
    // }

    if (searchText) {
      result = result.filter((item) =>
        (item.galleryName || '').includes(searchText?.trim() || '')
      );
    }

    if (gallerySortType === 'name') {
      result = [...result].sort((a, b) => {
        return a.name?.localeCompare?.(b?.name);
      });
    }
    // if (gallerySortType === 'filename') {
    //   result = [...result].sort((a, b) => {
    //     return a.avatar?.localeCompare?.(b?.avatar);
    //   });
    // }

    // console.log('result', result);
    return result;
  }, [
    galleryData,
    filterGallery,
    filterGalleryAssign,
    searchText,
    gallerySortType,
  ]);

  // remove tab index for Add text in image editor

  if (document.getElementsByClassName('photo-edit-modal')[0]) {
    document
      .getElementsByClassName('photo-edit-modal')[0]
      .removeAttribute('tabindex');
  }

  return (
    <div id='pageWrapper'>
      <div className='main-page'>
        <div className='page-wrapper'>
          <div className='header-topbar justify-content-between'></div>
          <section className='common-sec users-sec card-body-no-padding'>
            <div className='container-fluid'>
              <div className='row'>
                <div className='col-12'>
                  <Card>
                    <Card.Header>
                      <div className='card-header-inner filterW-btn'>
                        <div className='card-header-inner-left'>
                          <h2>Gallery</h2>
                          <div className='gallery-list-icon-wrapper'>
                            <ul>
                              <li
                                className={
                                  galleryListView === 'list' ? 'active' : ''
                                }
                                onClick={() => setGalleryListView('list')}>
                                <GridIcon />
                              </li>
                              <li
                                className={
                                  galleryListView === 'table' ? 'active' : ''
                                }
                                onClick={() => setGalleryListView('table')}>
                                <ListIcon />
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className='card-header-inner-right'>
                          <div className='contact-title'>
                            <Button
                              className='btn-sm me-2'
                              variant='primary'
                              onClick={() => {
                                setInitialValues((prevState) => ({
                                  ...prevState,
                                  isLogo: true,
                                }));
                                setModalAction('add');
                                setPreviewScreen({
                                  name: '',
                                  imageUrl: defaultGallery,
                                });
                                setShowModal(true);
                              }}>
                              <i className='fas fa-plus'></i> Add Thumnail
                            </Button>
                            <Button
                              className='btn-sm'
                              variant='primary'
                              onClick={() => {
                                setModalAction('add');
                                setInitialValues((prevState) => ({
                                  ...prevState,
                                  isLogo: false,
                                }));
                                setPreviewScreen({
                                  name: '',
                                  imageUrl: fullScreenDefault,
                                });
                                setShowModal(true);
                              }}>
                              <i className='fas fa-plus'></i> Add Full Screen
                            </Button>
                          </div>
                        </div>
                      </div>
                    </Card.Header>
                    <Card.Body>
                      <div className='contact-wrap'>
                        {isFirstLoading ? (
                          <div
                            style={{
                              minHeight: '300px',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                            }}>
                            <Spinner
                              as='span'
                              animation='border'
                              size='lg'
                              role='status'
                              aria-hidden='true'
                              color=''
                            />
                          </div>
                        ) : (
                          <>
                            <div className='container-fluid'>
                              <div className='row gallery-row'>
                                <div className='col-12 col-md-12 col-lg-12 mr-3'>
                                  <div className='contact-filter contact-filter-cs mb-3'>
                                    <div className='row flex-wrap flex-lg-nowrap'>
                                      <div
                                        style={{ width: 400 }}
                                        className='col-12 '>
                                        <div className='input-group w-100 mb-2 mb-lg-0'>
                                          <input
                                            className='form-control w-100'
                                            type='text'
                                            name='search'
                                            autocomplete='none'
                                            placeholder='Search'
                                            value={searchText}
                                            onChange={(e) => {
                                              setSearchText(e.target.value);
                                            }}
                                          />
                                          {searchText && (
                                            <svg
                                              onClick={() => {
                                                setSearchText('');
                                                searchData('');
                                              }}
                                              className='close-icon'
                                              xmlns='http://www.w3.org/2000/svg'
                                              width='30'
                                              height='30'
                                              viewBox='0 0 21 21'>
                                              <path
                                                fill='none'
                                                stroke='currentColor'
                                                stroke-linecap='round'
                                                stroke-linejoin='round'
                                                d='m7.5 7.5l6 6m0-6l-6 6'
                                              />
                                            </svg>
                                          )}
                                        </div>
                                      </div>
                                      <div className='col-12 col-lg-auto'>
                                        <div className='filter-wrapper mb-2 mb-lg-0'>
                                          <div className='gallery-sort-type-selectmenu text-nowrap'>
                                            <h2>Filter type: </h2>
                                          </div>
                                          <Select
                                            styles={{
                                              width: '200px',
                                            }}
                                            classNamePrefix='select'
                                            value={filterGallery}
                                            options={[
                                              {
                                                label: 'Select All',
                                                value: 'all',
                                              },
                                              {
                                                label: 'Full Screen',
                                                value: 'fullImage',
                                              },
                                              {
                                                label: 'Thumbnail',
                                                value: 'logo',
                                              },
                                            ]}
                                            onChange={(opt) =>
                                              setFilterGallery(opt)
                                            }
                                          />
                                        </div>
                                      </div>
                                      <div className='col-12 col-lg-auto'>
                                        <div className='filter-wrapper'>
                                          <div className='gallery-sort-type-selectmenu text-nowrap'>
                                            <h2>Filter assigned: </h2>
                                          </div>
                                          <Select
                                            styles={{
                                              width: '200px',
                                            }}
                                            classNamePrefix='select'
                                            value={filterGalleryAssign}
                                            options={[
                                              {
                                                label: 'Select All',
                                                value: 'all',
                                              },
                                              {
                                                label: 'Assigned',
                                                value: 'assigned',
                                              },
                                              {
                                                label: 'Unassigned',
                                                value: 'unassigned',
                                              },
                                            ]}
                                            onChange={(opt) =>
                                              setFilterGalleryAssign(opt)
                                            }
                                          />
                                        </div>
                                      </div>
                                      {/* <div className='col-12 col-lg-auto'>
                                        <div className='filter-wrapper'>
                                          <div className='gallery-sort-type-selectmenu'>
                                            <h2>Sort By</h2>
                                          </div>
                                          <Select
                                            name='userProfileId'
                                            className='basic-multi-select'
                                            classNamePrefix='select'
                                            options={gallerySortTypeOptions}
                                            value={
                                              gallerySortTypeOptions &&
                                              gallerySortTypeOptions.filter(
                                                (e) =>
                                                  e.value === gallerySortType
                                              )
                                            }
                                            onChange={(opt) => {
                                              setGallerySortType(opt.value);
                                            }}
                                          />
                                        </div>
                                      </div> */}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {galleryListView &&
                                galleryListView === 'list' && (
                                  <div
                                    style={{
                                      minHeight: '300px',
                                    }}
                                    className='user-data common-data-table'>
                                    <RcdImageComponent
                                      // key={galleryData}
                                      // galleryData={galleryData}
                                      galleryData={filterGalleryData}
                                      galleryImages={galleryImages}
                                      setGalleryData={setGalleryData}
                                      setGalleryImages={setGalleryImages}
                                      setBlobURL={setBlobURL}
                                      blobURL={blobURL}
                                      member='gallery'
                                      setEditInitialValues={
                                        setEditInitialValues
                                      }
                                      setPreviewScreen={setPreviewScreen}
                                      initialPreviewScreen={
                                        initialPreviewScreen
                                      }
                                      setModalAction={setModalAction}
                                      setShowModal={setShowModal}
                                      flag={false}
                                      imageContactData={imageContactData}
                                      setFilterContact={setFilterContact}
                                      setRemoveGalleryIdContact={
                                        setRemoveGalleryIdContact
                                      }
                                      //
                                      onRemove={handleRemove}
                                    />
                                  </div>
                                )}
                            </div>
                            <div>
                              {galleryListView &&
                                galleryListView === 'table' && (
                                  <div
                                    style={{
                                      minHeight: '300px',
                                    }}
                                    className='user-data common-data-table'>
                                    <TableComponent
                                      key={tableKeyState}
                                      columns={columns}
                                      // data={galleryData}
                                      data={filterGalleryData}
                                    />
                                  </div>
                                )}
                            </div>
                          </>
                        )}
                      </div>
                    </Card.Body>
                  </Card>
                </div>
                {modalAction && (
                  <Modal
                    size='md'
                    show={showModal}
                    onHide={handleClose}
                    className='gallery-update-modal'
                    backdrop='static'
                    centered>
                    <Modal.Header closeButton>
                      <Modal.Title>
                        {modalAction === 'add' ? (
                          <h2>
                            Add{' '}
                            {initialValues.isLogo ? 'Thumbnail' : 'Full Screen'}
                          </h2>
                        ) : (
                          <h2>
                            Edit{' '}
                            {editInitialValues.isLogo
                              ? 'Thumbnail'
                              : 'Full Screen'}
                          </h2>
                        )}
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <div className='row'>
                        <div className='col-12 col-lg-12 col-md-12 col-sm-12'>
                          <div className='edit-detail-inner'>
                            <div>
                              <Formik
                                enableReinitialize={true}
                                initialValues={
                                  modalAction === 'add'
                                    ? initialValues
                                    : editInitialValues
                                }
                                validationSchema={validationSchema}
                                onSubmit={(value, { resetForm }) => {
                                  return submitFunction(value);
                                }}>
                                {({
                                  values,
                                  errors,
                                  isValid,
                                  setFieldValue,
                                  isSubmitting,
                                }) => (
                                  <Form>
                                    <div>
                                      {modalAction === 'add' ? null : (
                                        <div>
                                          <Field type='hidden' name='id' />
                                          <FieldArray
                                            type='hidden'
                                            name='contactId'
                                          />
                                        </div>
                                      )}

                                      <div className='user-modal-filed-wrapper'>
                                        <div className='row'>
                                          <div className='col-12 col-md-12 col-lg-12'>
                                            <div className='gallery-image'>
                                              <div
                                                className='form-group file-upload d-flex'
                                                // onClick={
                                                //   (e) =>
                                                //     modalAction === 'edit'
                                                //       ? galleryImages[editInitialValues.id] &&
                                                //         handleImageEditClick(editInitialValues)
                                                //       : handleImageEditClick(editInitialValues)
                                                //   // setProfileDropzone(!profileDropzone)
                                                // }
                                                onClick={(e) => {
                                                  setIsUploadImage(
                                                    values.isLogo
                                                      ? 'logo'
                                                      : 'fullImage'
                                                  );
                                                }}>
                                                <MyDropZoneLogo
                                                  objectType={isUploadImage}
                                                  onChange={(value) => {
                                                    if (isUploadImage) {
                                                      // setFieldValue(
                                                      //   'imageUrl',
                                                      //   value?.preview
                                                      // );
                                                      // setFieldValue(
                                                      //   `${isUploadImage}File`,
                                                      //   value
                                                      // );

                                                      setIsUploadImage('');

                                                      setEditImageData({
                                                        type: values.isLogo
                                                          ? 'logo'
                                                          : 'fullscreen',
                                                        isOpen: true,
                                                        imageUrl:
                                                          value?.preview || '',
                                                        name:
                                                          values?.galleryName ||
                                                          value?.name,
                                                      });
                                                    }
                                                  }}>
                                                  <div
                                                    onClick={(e) => {
                                                      if (values.imageUrl) {
                                                        setIsUploadImage('');

                                                        setEditImageData({
                                                          type: values.isLogo
                                                            ? 'logo'
                                                            : 'fullscreen',
                                                          isOpen: true,
                                                          imageUrl:
                                                            values.imageUrl ||
                                                            '',
                                                          name: values?.galleryName,
                                                        });
                                                        e.stopPropagation();
                                                      }
                                                    }}
                                                    className='d-flex align-items-center'>
                                                    <img
                                                      style={{
                                                        margin: '0 auto',
                                                      }}
                                                      alt=''
                                                      src={
                                                        values.imageUrl
                                                          ? values.imageUrl
                                                          : initialValues.isLogo
                                                          ? defaultGallery
                                                          : fullScreenDefault
                                                      }
                                                      onError={(e) => {
                                                        e.target.src =
                                                          defaultGallery;
                                                      }}
                                                    />
                                                    <span
                                                      style={{
                                                        color: '#666666',
                                                      }}>
                                                      {!values.imageUrl
                                                        ? 'Select Image'
                                                        : 'Edit image'}
                                                    </span>
                                                  </div>
                                                  {modalAction === 'edit' && (
                                                    <div className='mt-3'>
                                                      <Button

                                                      // onClick={() => {
                                                      //   setIsUploadImage(
                                                      //     'fullImage'
                                                      //   );
                                                      // }}
                                                      >
                                                        Select Image
                                                      </Button>
                                                    </div>
                                                  )}
                                                </MyDropZoneLogo>
                                              </div>

                                              {/* <div>
                                              
                                              </div> */}
                                            </div>
                                          </div>
                                          <div className='col-12 col-md-12 col-lg-12'>
                                            <div className='form-group'>
                                              <Field
                                                className='form-control'
                                                type='text'
                                                name='galleryName'
                                                placeholder='Name'
                                                onChange={(e) => {
                                                  setPreviewScreen(
                                                    (prevState) => ({
                                                      ...prevState,
                                                      galleryName:
                                                        e.target.value,
                                                    })
                                                  );
                                                  setFieldValue(
                                                    'galleryName',
                                                    e.target.value
                                                  );
                                                }}
                                              />
                                              <div className='form-group'>
                                                <ErrorMessage name='galleryName'>
                                                  {(msg) => (
                                                    <span
                                                      className='fm_error'
                                                      style={{ color: 'red' }}>
                                                      {msg}
                                                    </span>
                                                  )}
                                                </ErrorMessage>
                                              </div>
                                            </div>
                                            {/* <div className='form-group'>
                                              <Field
                                                className='form-control'
                                                type='text'
                                                name='imageUrl'
                                                placeholder={
                                                  previewScreen.isLogo
                                                    ? 'Logo Url'
                                                    : 'Full Screen URL'
                                                }
                                                onChange={(e) => {
                                                  setPreviewScreen(
                                                    (prevState) => ({
                                                      ...prevState,
                                                      imageUrl: e.target.value,
                                                    })
                                                  );
                                                  setFieldValue(
                                                    'imageUrl',
                                                    e.target.value
                                                  );
                                                }}
                                              />
                                              <ErrorMessage name='imageUrl'>
                                                {(msg) => (
                                                  <span
                                                    className='fm_error'
                                                    style={{ color: 'red' }}>
                                                    {msg}
                                                  </span>
                                                )}
                                              </ErrorMessage>
                                            </div> */}

                                            <div className='form-group'>
                                              <Select
                                                styles={stylesSelectAssign}
                                                isMulti
                                                components={{
                                                  MultiValueLabel:
                                                    MultiValueLabelCustom,
                                                }}
                                                name='rcdAssign'
                                                defaultValue={
                                                  rcdOptionsAssign &&
                                                  orderOptions(
                                                    rcdOptionsAssign
                                                      .filter((e) =>
                                                        values?.contactId?.includes(
                                                          e.value.id
                                                        )
                                                      )
                                                      .map((item) => ({
                                                        ...item,
                                                        // isFixed:
                                                        //   item.value.id ===
                                                        //   values.id,
                                                      }))
                                                  )
                                                }
                                                className='basic-multi-select'
                                                classNamePrefix='select'
                                                value={values.rcdAssign}
                                                onChange={(opt, actionMeta) => {
                                                  contactSelectFunction(
                                                    opt,
                                                    actionMeta,
                                                    setFieldValue
                                                  );
                                                }}
                                                options={rcdOptionsAssign.filter(
                                                  (item) =>
                                                    item.value.id !== values.id
                                                )}
                                                isClearable={values.contactId.some(
                                                  (v) => v !== values.id
                                                )}
                                                filterOption={
                                                  customFilterSelectContact
                                                }
                                                getOptionLabel={(option) => (
                                                  <div>
                                                    <div>
                                                      {getOnlyFirstName(
                                                        option.label
                                                      )}
                                                    </div>
                                                    <div
                                                      style={{
                                                        fontSize: 14,
                                                      }}>
                                                      {option?.value?.number}
                                                    </div>
                                                  </div>
                                                )}
                                              />
                                            </div>
                                            <div className='custom_append_number'>
                                              {values.contactId &&
                                                values.contactId.length !==
                                                  0 && <p>Numbers Included</p>}
                                              {/* <div className='number_cs_field_wrapper'>
                                                {rcdOptionsAssign?.map(
                                                  (e, index) =>
                                                    values.contactId?.length >
                                                      0 &&
                                                    values.contactId.includes(
                                                      e.value.id
                                                    ) && (
                                                      <span
                                                        className='number_cs_field'
                                                        key={index}>
                                                        {e.value.number}
                                                      </span>
                                                    )
                                                )}
                                              </div> */}
                                              <div className='number_cs_field_wrapper'>
                                                {values.contactId
                                                  ?.sort((a) =>
                                                    a !== values.id ? 1 : -1
                                                  )
                                                  .map(
                                                    (contactIdItem, index) => {
                                                      const findItem =
                                                        rcdOptionsAssign.find(
                                                          (v) =>
                                                            v.value.id ===
                                                            contactIdItem
                                                        );

                                                      return (
                                                        findItem && (
                                                          <span
                                                            className='number_cs_field'
                                                            key={index}>
                                                            {
                                                              findItem.value
                                                                .number
                                                            }
                                                          </span>
                                                        )
                                                      );
                                                    }
                                                  )}
                                              </div>
                                            </div>

                                            <div className='form-group'>
                                              <ErrorMessage name='imageUrl'>
                                                {(msg) => (
                                                  <span
                                                    className='fm_error'
                                                    style={{ color: 'red' }}>
                                                    {msg}
                                                  </span>
                                                )}
                                              </ErrorMessage>
                                            </div>
                                          </div>

                                          <div className='col-12 col-md-12 col-lg-12'>
                                            {modalAction === 'add' ? (
                                              <div className='text-end'>
                                                <button
                                                  disabled={isSubmitting}
                                                  type='submit'
                                                  className='btn btn-primary'>
                                                  Add
                                                </button>
                                              </div>
                                            ) : (
                                              <div className='text-end'>
                                                <button
                                                  type='submit'
                                                  className='btn btn-primary'
                                                  disabled={isSubmitting}>
                                                  <span>Save</span>
                                                </button>
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                      {/* {isUploadImage === 'xxx' && (
                                        <>
                                          <Modal
                                            key='modal-upload'
                                            size='sm'
                                            show={isUploadImage}
                                            onHide={() =>
                                              setIsUploadImage(false)
                                            }
                                            backdrop='static'
                                            centered>
                                            <Modal.Header closeButton>
                                              <Modal.Title></Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body>
                                              <>
                                                <div className='mydropzone-contactbtn'>
                                                  <MyDropZoneLogo
                                                    objectType={isUploadImage}
                                                    onChange={(value) => {
                                                      if (isUploadImage) {
                                                        console.log(
                                                          '???',
                                                          value
                                                        );
                                                        setFieldValue(
                                                          'imageUrl',
                                                          value?.preview
                                                        );
                                                        setFieldValue(
                                                          `${isUploadImage}File`,
                                                          value
                                                        );
                                                        setIsUploadImage('');
                                                      }
                                                    }}
                                                  />
                                                </div>
                                              </>
                                            </Modal.Body>
                                          </Modal>
                                        </>
                                      )} */}
                                      <ImageEditorModal
                                        isOpenModal={editImageData.isOpen}
                                        onHide={handleCloseEditImage}
                                        imageUrl={editImageData.imageUrl}
                                        type={editImageData.type}
                                        isSaveAsNew={false}
                                        previewData={{
                                          ...values,
                                          formatName: 'Sample Name',
                                          currentGallery: gradientDefaultRinger,
                                          currentGalleryCircle:
                                            gradientDefaultRinger,
                                        }}
                                        onChange={(value) => {
                                          if (editImageData.type) {
                                            setFieldValue(
                                              'imageUrl',
                                              value?.preview
                                            );

                                            if (editImageData.type === 'logo') {
                                              setFieldValue(`logoFile`, value);
                                            } else {
                                              setFieldValue(
                                                `fullImageFile`,
                                                value
                                              );
                                            }
                                          }
                                        }}
                                      />
                                    </div>
                                  </Form>
                                )}
                              </Formik>
                            </div>
                            <div></div>
                          </div>
                        </div>
                      </div>
                    </Modal.Body>
                  </Modal>
                )}
              </div>
              <ImageModal
                showImageEditor={showImageEditor}
                setShowImageEditor={setShowImageEditor}
                imageHandleClose={imageHandleClose}
                blobURL={blobURL}
                setBlobURL={setBlobURL}
                setTab={setTab}
                tab={tab}
                setPreviewScreen={setPreviewScreen}
                previewScreen={previewScreen}
                imageEditData={imageEditData}
                setImageEditData={setImageEditData}
                isSaveAsNew
              />

              <Modal
                size='lg'
                show={showGalleryModal}
                onHide={() => {
                  setShowGalleryModal(false);
                  setShowImageEditor(false);
                }}
                className='contact-update-modal contact-update-modal-vh'
                backdrop='static'>
                <Modal.Header closeButton>
                  <Modal.Title></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <GalleryImage
                    galleryData={galleryData}
                    galleryImages={galleryImages}
                    setGalleryData={setGalleryData}
                    setGalleryImages={setGalleryImages}
                    setBlobURL={setBlobURL}
                    blobURL={blobURL}
                    setShowGalleryModal={setShowGalleryModal}
                    setPreviewScreen={setPreviewScreen}
                    setGalleryFileName={setGalleryFileName}
                    setShowImageEditor={setShowImageEditor}
                  />
                </Modal.Body>
              </Modal>
            </div>
          </section>
        </div>
      </div>
      <FooterEnd />
    </div>
  );
};

const mapStateToProps = ({
  activeTabReducer: { showModal, modalAction },
  authReducer: { userRole },
}) => ({
  showModal: showModal,
  modalAction: modalAction,
  userRole: userRole,
});

const mapDispatchToProps = (dispatch) => ({
  setToaster: (data) => dispatch(showToast(data)),
  setShowModal: (data) => dispatch(setShowModal(data)),
  setModalAction: (data) => dispatch(setModalAction(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(GalleryView);
